var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeny(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Denied") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_4tuafW.tif",
    "data-name": "4tuafW.tif"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.13,6.36a1.25,1.25,0,0,0,.22-1,1.94,1.94,0,0,0-.45-.79.2.2,0,0,1,0-.23A1.51,1.51,0,0,0,14,3.49a1.67,1.67,0,0,0-.39-.73.6.6,0,0,1-.14-.66.89.89,0,0,0-.22-.93,2.18,2.18,0,0,0-1.17-.7c-.6-.13-1.21-.24-1.82-.35C9.93.06,9.6,0,9.29,0H8.55C8.28,0,8,.07,7.72.13c-.64.15-1.27.33-1.9.46-.44.09-.89.13-1.33.19A.22.22,0,0,1,4.35.72.94.94,0,0,0,3.63.41H1.56a.93.93,0,0,0-.95,1V6.78a.93.93,0,0,0,.93,1H3.67a1,1,0,0,0,.63-.25,1.85,1.85,0,0,1,.62.71c.2.43.39.87.55,1.31a3.71,3.71,0,0,0,.79,1.29c.18.18.35.38.54.54a3,3,0,0,1,1,1.75c.06.28.11.57.15.86A1.16,1.16,0,0,0,8.82,15H9.2a1.8,1.8,0,0,0,1.11-1.16,4.43,4.43,0,0,0,.25-.88,2.72,2.72,0,0,0-.41-2.09c-.2-.29-.37-.6-.55-.91a2.94,2.94,0,0,1-.16-.31,1.12,1.12,0,0,1,.27-.1c.17,0,.34,0,.51,0l2.28-.06a1.77,1.77,0,0,0,1.41-.68,1.5,1.5,0,0,0,.21-1.95A.42.42,0,0,1,14.13,6.36Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeny);
export default __webpack_public_path__ + "static/media/deny.f456fe8065b55f6f5288e68bc755f5db.svg";
export { ForwardRef as ReactComponent };